(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'CarBooking',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.confirmation = function confirmation(response)
	{
		Adzuki.Erez.ClientDuplicateEmail.confirm(response, form.name);
	};

	form.load = function load($form)
	{
		Adzuki.Typeahead(
			'#carbooking-merge_into_reservation',
			'/Searches/recipient/reservation/',
			function selected(item, $self, typeahead) {
				typeahead.setHiddenValue(item.id);
			}
		);

		// if selecting an existing client, get their cc info to pre-fill fields
		$(".existing-client.adzuki-typeahead").on('ta.set-hidden', function getAddresses(e, client_id)
		{
			Adzuki.Ajax.get('/ClientAddresses/getAddressesByClientId/'+client_id+'/1')
			.then(function fillAddresses(addresses)
			{
				$('#carbooking-address1').val(addresses[0].address1);
				$('#carbooking-address2').val(addresses[0].address2);
				$('#carbooking-city').val(addresses[0].city);
				$('#carbooking-state').val(addresses[0].state_iso_code);
				$('#carbooking-zip').val(addresses[0].zip);
			});
		})
		.on('ta.reset', function resetAddressFields() {
			$('#carbooking-address1').val('');
			$('#carbooking-address2').val('');
			$('#carbooking-city').val('');
			$('#carbooking-state').val('');
			$('#carbooking-zip').val('');
		});

		Adzuki.CharacterCount('#carbooking-special_preferences', {
			max  : 60,
			label: '#special-preferences-count',
		});
	};
}(jQuery, window.Adzuki || {}));
